const Paragraph = ({ text }) => {
  if (text.startsWith("Important:")) {
    return (
      <p className="text-spark-ink text-sm sm:text-[15px] leading-relaxed bg-spark-yellow/15 border-l-4 border-spark-yellow px-4 py-3 rounded-sm">
        <strong>Important:</strong>{text.slice("Important:".length)}
      </p>
    );
  }
  return <p className="text-spark-slate text-sm sm:text-[15px] leading-relaxed">{text}</p>;
};

const Blocks = ({ blocks }) => (
  <div className="space-y-3">
    {blocks.map((b, i) => Array.isArray(b) ? (
      <ul key={i} className="list-disc pl-5 sm:pl-6 space-y-1.5 text-spark-slate text-sm sm:text-[15px] leading-relaxed marker:text-spark-teal">
        {b.map((li) => <li key={li}>{li}</li>)}
      </ul>
    ) : <Paragraph key={i} text={b} />)}
  </div>
);

export const sectionId = (s) => (s.n ? `section-${s.n}` : `section-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`);

export const TermsSection = ({ s, compact }) => (
  <article id={sectionId(s)} className={`scroll-mt-24 ${compact ? "" : "surface-card p-5 sm:p-7"}`} data-testid={`terms-${sectionId(s)}`}>
    <h3 className={`font-display uppercase tracking-tight font-bold text-spark-ink mb-3 flex gap-3 ${compact ? "text-base" : "text-lg sm:text-xl"}`}>
      {s.n && <span className="text-spark-teal shrink-0">{s.n}.</span>}
      <span>{s.title}</span>
    </h3>
    <Blocks blocks={s.blocks} />
  </article>
);

export const TermsContact = ({ contact, compact }) => (
  <article id="section-contact" className={`scroll-mt-24 ${compact ? "" : "surface-card p-5 sm:p-7"}`} data-testid="terms-section-contact">
    <h3 className={`font-display uppercase tracking-tight font-bold text-spark-ink mb-3 ${compact ? "text-base" : "text-lg sm:text-xl"}`}>{contact.title}</h3>
    <div className="space-y-3 text-sm sm:text-[15px] leading-relaxed text-spark-slate">
      <p>{contact.intro}</p>
      <address className="not-italic text-spark-ink border-l-4 border-spark-teal pl-4 py-1 space-y-0.5">
        <p className="font-bold">{contact.name}</p>
        <p>{contact.location}</p>
        <p>Email: <a href={`mailto:${contact.email}`} className="text-spark-teal-dark underline break-all" data-testid="terms-contact-email">{contact.email}</a></p>
        <p>Website: <a href={contact.website} className="text-spark-teal-dark underline break-all">{contact.website}</a></p>
      </address>
      <p>{contact.outro}</p>
    </div>
  </article>
);

export const TermsBody = ({ terms, compact = false }) => (
  <div className={compact ? "space-y-6" : "space-y-5"} data-testid="terms-body">
    <div className="space-y-3">
      {terms.intro.map((p) => <p key={p} className="text-spark-ink text-sm sm:text-base leading-relaxed">{p}</p>)}
    </div>
    {terms.sections.map((s) => <TermsSection key={s.n} s={s} compact={compact} />)}
    {terms.closing_sections.map((s) => <TermsSection key={s.title} s={s} compact={compact} />)}
    <TermsContact contact={terms.contact} compact={compact} />
  </div>
);
